export const iconFontAwesomeShoppingThumbsUp = (
	<i className="fa-solid fa-thumbs-up"></i>
);
